var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
var PERMISSIONS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query Team($id: ID!) {\n    team(id: $id) {\n      id\n      name\n      permissions\n    }\n  }\n"], ["\n  query Team($id: ID!) {\n    team(id: $id) {\n      id\n      name\n      permissions\n    }\n  }\n"])));
export var usePermissionsQuery = function (options) { return useQuery(PERMISSIONS, options); };
export default PERMISSIONS;
var templateObject_1;
